
import { GridColDef } from "@mui/x-data-grid";

import { ITest, IInstallation, IBooking, IContact } from "@initia-digital/types/work-and-safety";
import { EditTextArea } from "@initia-digital/component-library";

// ---------------------
export const NEW_TESTS_REQUIRED_ROW_TEMPLATE = {
    testQuantity: 0,
    testType: '',
    testTargetDepth: 0,
    testNotes: ''
} as ITest;

// ---------------------
export const TESTS_REQUIRED_COL_DEFS = [
    {
        field: 'testQuantity',
        type: 'number',
        headerName: 'Quantity',
        editable: true,
        minWidth: 100
    },
    {
        field: 'testType',
        type: 'singleSelect',
        valueOptions: [
            'Machine borehole', 'Hand auger',
            'Scala penetrometer', 'CPT', 'Push tube',
            'Bulk sample', 'Test pit', 'Nuclear densometer',
            'Other'
        ],
        headerName: 'Type',
        editable: true,
        minWidth: 165
    },
    {
        field: 'testTargetDepth',
        type: 'number',
        headerName: 'Target Depth (m)',
        editable: true,
        minWidth: 135
    },
    {
        field: 'testNotes',
        headerName: 'Notes',
        editable: true,
        minWidth: 200,
        renderEditCell: (params) => <EditTextArea {...params} />
    }
] as GridColDef<ITest>[];

// ---------------------
export const NEW_INSTALLATIONS_REQUIRED_ROW_TEMPLATE = {
    installationQuantity: 0,
    installationType: '',
    installationNotes: ''
} as IInstallation;

// ---------------------
export const INSTALLATIONS_REQUIRED_COL_DEFS = [
    {
        field: 'installationQuantity',
        type: 'number',
        headerName: 'Quantity',
        editable: true,
        width: 100
    },
    {
        field: 'installationType',
        type: 'singleSelect',
        valueOptions: ['Standpipe piezometer', 'Other'],
        headerName: 'Type',
        editable: true,
        width: 200
    },
    {
        field: 'installationNotes',
        headerName: 'Notes',
        editable: true,
        width: 200,
        renderEditCell: (params) => <EditTextArea {...params} />
    }
] as GridColDef<IInstallation>[];

// ---------------------
export const NEW_BOOKING_ROW_TEMPLATE = {
    contractorOrSubcontractor: '',
    bookingType: '',
    bookingNotes: ''
} as IBooking;

// ---------------------
export const BOOKINGS_COL_DEFS = [
    {
        field: 'contractorOrSubcontractor',
        type: 'string',
        headerName: 'Contractor',
        editable: true,
        width: 150
    },
    {
        field: 'bookingType',
        type: 'string',
        headerName: 'Type',
        editable: true,
        width: 280
    },
    {
        field: 'bookingNotes',
        headerName: 'Notes',
        editable: true,
        width: 200,
        renderEditCell: (params) => <EditTextArea {...params} />
    }
] as GridColDef<IBooking>[];

// ---------------------
export const NEW_CONTACT_ROW_TEMPLATE = {
    contactName: '',
    contactOrg: '',
    contactNumber: '',
    contactEmail: '',
    isOrgMain: false
} as IContact;

// ---------------------
export const CONTACT_COL_DEFS = [
    {
        field: 'contactName',
        type: 'string',
        headerName: 'Contact',
        editable: true,
        width: 200
    },
    {
        field: 'contactOrg',
        type: 'string',
        headerName: 'Organization',
        editable: true,
        width: 200
    },
    {
        field: 'contactNumber',
        type: 'string',
        headerName: 'Phone',
        editable: true,
        width: 150
    },
    {
        field: 'contactEmail',
        type: 'string',
        headerName: 'Email',
        editable: true,
        width: 200
    }
] as GridColDef<IContact>[];